import type { ReactNode } from 'react'

interface PageHeaderProps {
  eyebrow: string
  title: string
  description: string
  icon?: ReactNode
  actions?: ReactNode
}

const PageHeader = ({ eyebrow, title, description, icon, actions }: PageHeaderProps) => (
  <header className="page-header">
    <div className="page-header-copy">
      <div className="flex items-center gap-3">
        {icon && <span className="page-header-icon" aria-hidden="true">{icon}</span>}
        <p className="eyebrow !mb-0">{eyebrow}</p>
      </div>
      <h1>{title}</h1>
      <p>{description}</p>
    </div>
    {actions && <div className="page-header-actions">{actions}</div>}
  </header>
)

export default PageHeader
